window.TableData = (function($, _) {
    /**
     * @type {{}||Object<string, VitalityTable>}
     */
    window.VitalityTables = window.VitalityTables || {};
    const self = {
        selectors: {
            tableFrames: '.table-frame',
            preloadedDataTable: '.vds-table__table[data-loading-strategy="preload"]',
            skeletonPlaceholder: '.vds-placeholder',
            tableHeaders: '.vds-table__header'
        },
        attr: {
            dataEndpoint: 'data-api-endpoint',
            dataLabel: 'data-label',
            dataRowKey: 'data-row-key',
        },
        classNames: {
            hidden: 'vds-item-hidden'
        },
        links: {
            errorPage: '/error/error-page'
        },
        state: {
            channel: new BroadcastChannel('table-frame-update'),
        },
        func: {
            init: function () {
                self.state.channel.addEventListener('message', (event) => {
                    let tableId = event.data;
                    self.func.handleTableFrameUpdate(tableId);
                });
                $(self.selectors.preloadedDataTable).each((_index, element) => {
                    let table =  $(element).closest(self.selectors.tableFrames);
                    let tableId =  table.attr('id');

                    window.VitalityTables[tableId] = window.VitalityTables[tableId] || {
                        tableFrame: {},
                        tableData: {}
                    };

                    let apiEndpoint = table.find(self.selectors.preloadedDataTable).attr(self.attr.dataEndpoint);
                    if (apiEndpoint) {
                        $.get(apiEndpoint).then(data => {
                            if (!data.isPopulated) {
                                self.func.redirectToErrorPage();
                            } else {
                                window.VitalityTables[tableId].tableData = {
                                    isPopulated: data.isPopulated,
                                    columns: self.func.getColumns(table),
                                    rows: data.rows
                                };
                                table.find(self.selectors.skeletonPlaceholder).addClass(self.classNames.hidden);
                                table.find(self.selectors.preloadedDataTable).removeClass(self.classNames.hidden);
                                self.func.handleTableFrameUpdate(tableId);
                            }
                        }, () => {
                            self.func.redirectToErrorPage();
                        });
                    }
                });
            },
            getColumns: function(table) {
                let headerElements = table.find(self.selectors.tableHeaders);
                let columns = [];
                headerElements.each((index, element) => {
                    let col = {
                        label: $(element).attr(self.attr.dataLabel),
                        rowKey: $(element).attr(self.attr.dataRowKey),
                        columnNumber: index + 1
                    };
                    columns.push(col);
                });
                return columns;
            },
            filterFunction: function (columns, filters) {
                let valuesByColumnNumber = {};
                for (let filter of filters) {
                    valuesByColumnNumber[filter.columnNumber] ||= [];
                    valuesByColumnNumber[filter.columnNumber].push(filter.filterValue);
                }
                let keys = Object.keys(valuesByColumnNumber);
                return (row) => {
                    for (let key of keys) {
                        let intKey = _.parseInt(key);
                        let values = valuesByColumnNumber[keys];
                        let filterColumnKey = _.find(columns, {columnNumber: intKey}).rowKey;
                        if (!values.includes(row[filterColumnKey])) {
                            return false;
                        }
                    }
                    return true;
                };
            },
            sortColumnKey: function (columns, sort) {
                let sortColumnNumber = _.parseInt(sort.columnNumber);
                let sortColumn = _.find(columns, {columnNumber: sortColumnNumber});
                return sortColumn.rowKey;
            },
            handleTableFrameUpdate: function (tableId) {
                let vitalityTable = window.VitalityTables[tableId];
                if (!vitalityTable || !vitalityTable.tableFrame.isPopulated || !vitalityTable.tableData.isPopulated) {
                    return;
                }

                let frame = _.cloneDeep(vitalityTable.tableFrame);
                let data = _.cloneDeep(vitalityTable.tableData);
                let displayRows = data.rows;

                try {
                    displayRows = _.filter(displayRows, self.func.filterFunction(data.columns, frame.filters));
                } catch {
                    // If something goes wrong during filter, just show all rows
                }

                try {
                    let sortKey = [self.func.sortColumnKey(data.columns, frame.sort)];
                    let sortDirection = [frame.sort.sortDirection];
                    displayRows = _.orderBy(displayRows, sortKey, sortDirection);
                } catch {
                    // If something goes wrong during sort, just show in the order from server
                }

                self.func.drawTable(tableId, data.columns, displayRows);
            },
            drawTable: function(tableId, columns, rows) {
                let tableBody = $(`#${tableId} .vds-table__body`);
                tableBody.empty();
                for (let row of rows) {
                    let snippet = '<tr>';
                    for (let column of columns) {
                        let cell = row.labels[column.rowKey];
                        if (!cell) {
                            cell = row[column.rowKey];
                        }
                        snippet += `
                        <td class="vds-table__cell" data-label="${column.label}">
                            <span class="vds-table__data">
                                ${cell}
                            </span>
                        </td>`;
                    }
                    snippet += '</tr>';
                    tableBody.append(snippet);
                }
            },
            redirectToErrorPage: function() {
                window.location.replace(self.links.errorPage);
            }
        }
    };

    return {
        init: self.func.init
    };
})(window.jQuery, window._);

$('document').ready(function () {
    window.TableData.init();
});
